import { request, PageResult } from './request';

export interface AdminUser {
    id: number;
    uuid: string;
    email: string;
    displayName?: string;
    createdBy: number;
    updatedBy: number;
    /** 授予人 uid: 最近一次授权决策的操作者 (提升为管理员的人) */
    reviewedBy?: number;
    /** 授予人用户名 (后端按 reviewedBy 批量解析) */
    reviewedByName?: string;
    /** 授予时间 (unix 秒): 最近一次授权决策的时间 */
    reviewedAt?: number;
    remark?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface ListAdminUsersParams {
    keyword?: string;
    page?: number;
    pageSize?: number;
}

const BASE = '/v1';

export function listAdminUsers(params: ListAdminUsersParams): Promise<PageResult<AdminUser>> {
    return request<PageResult<AdminUser>>(`${BASE}/admin-users`, { query: params });
}

// 直接授予管理员的接口已下线 (2026-08-26): 管理员统一由「普通用户」页提升而来 (promoteUser).

export function updateAdminDisplayName(email: string, displayName: string): Promise<null> {
    return request(`${BASE}/admin-users/update`, {
        method: 'POST',
        body: { email, displayName },
    });
}

export function revokeAdmin(email: string): Promise<null> {
    return request(`${BASE}/admin-users/revoke`, { method: 'POST', body: { email } });
}
